import { TrackingService } from '../../../react4xp/parts/tracking-service/tracking-service'

export default (props) => <TrackingService {...props} />
